import React from "react";
import { TableBody, TableRow } from "@mui/material";
import Message from "../../../../pages/components/message";
import { MessageSections } from "../../../../pages/components/message/message";
import { OrdersTableColumn } from "../../../../pages/orders/my/models/column-models";
import {
    OrderListContainer,
    OrderTable,
    OrderTableCell,
    OrderTableRow
} from "../../../../pages/orders/my/order-list/styled";
import { RowCell } from "../../../../pages/orders/my/order-list/cell/row-cell";
import NoOrders from "../../../../pages/orders/my/no-orders";
import BarekamText from "../../../../pages/components/text";
import { OrderModel } from "../../../../pages/shared/models/order/order-item.model";
import { BulkActionPopupActionTypes, InWarehouseActionTypes, ReadyForShipmentActionTypes } from "../../action-types.enum";
import { ActionDialogOrderListHeader } from "../styled";
import { useOutletContext } from "react-router-dom";
import { OutletContext } from "../../../../router/router";


const ActionDialogOrderList = ({ orders, columns, updateOrders }: ActionDialogOrderListProps) => {
    const outletContext = useOutletContext<OutletContext>();

    function onAction(row: OrderModel, action: InWarehouseActionTypes | ReadyForShipmentActionTypes | BulkActionPopupActionTypes) {
        switch (action) {
            case BulkActionPopupActionTypes.REMOVE:
                updateOrders(orders.filter(order => order.internalTrackingNumber !== row.internalTrackingNumber));
        }
    }

    const OrderListTableHead = (props: any) => {
        return (
            <ActionDialogOrderListHeader>
                <TableRow>
                    {columns.map((column, index) => (
                        <OrderTableCell key={`${index}-${column.field}`}>
                            <BarekamText variant={'m'} align={index === columns.length - 1 ? 'right' : 'left'} fontWeight={600}>
                                <Message messageKey={column.headerName} sectionId={MessageSections.ORDERS} />
                            </BarekamText>
                        </OrderTableCell>
                    ))}
                </TableRow>
            </ActionDialogOrderListHeader>
        )
    }

    return (
        <OrderListContainer>
            {orders.length
                ? <OrderTable width={'100%'}>
                    <OrderListTableHead onSelectAllClick={() => void (0)}
                        numSelected={0}
                        rowCount={orders.length} />

                    <TableBody>
                        {orders.map((order, index) => {
                            return (
                                <OrderTableRow
                                    hover
                                    tabIndex={index}
                                    key={`${index}-${order.orderId}`}>
                                    {columns.map((column, columnIndex) => {
                                        return (
                                            <RowCell cellVariant={column.variant}
                                                field={column.field}
                                                row={order}
                                                groups={[]}
                                                isName={columnIndex === 0}
                                                key={`${columnIndex}-${order.orderId}-${column.field}`}
                                                clicked={() => void (0)}
                                                payButtonClicked={() => void (0)}
                                                onAction={onAction}
                                                isWarehouseWorker={outletContext.isWarehouseWorker}
                                            />
                                        )
                                    })}
                                </OrderTableRow>
                            );
                        })}
                    </TableBody>
                </OrderTable>
                : 'isLoading' ? <></> : <NoOrders />
            }
        </OrderListContainer>
    );
}

interface ActionDialogOrderListProps {
    orders: OrderModel[],
    columns: OrdersTableColumn[],
    updateOrders: (orders: OrderModel[]) => void,
}

export default ActionDialogOrderList;